import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';

import '../i18n/config';
import OutschoolIcon from './outschool-icon.svg';
import TopicEnglish from './english.png';
import TopicMath from './math.png';
import TopicScience from './science.png';
import TopicMusic from './music.png';
import TopicPreK from './pre-k.png';
import TopicLifeSkills from './life-skills.png';

export interface Props {
  trackingCallback(event: string, params?: Record<string, unknown>): Promise<void>;
}

export const OutschoolCard = ({ trackingCallback }: Props): JSX.Element => {
  const { t } = useTranslation();

  const handleLinkClicked = (): Promise<void> => {
    const trackingProps = {
      elementId: 'outschool-search-card',
    };

    return trackingCallback('clicked-button', trackingProps);
  };

  useEffect(() => {
    const trackingProps = {
      elementId: 'outschool-search-card',
    };

    trackingCallback('viewed outschool-search-card', trackingProps);
  }, [trackingCallback]);

  return (
    <a
      href='https://outschool.com/online-classes/tutoring?adminTags=urban_sitting_btoc'
      onClick={handleLinkClicked}
      target='_blank'
      rel='noreferrer'
    >
      <div className='bg-white max-w-[410px] text-base rounded-3xl mt-3 shadow-md shadow-sapphire-50 hover:bg-sapphire-50 p-4'>
        <div className='flex'>
          <div className='flex-none mr-6'>
            <img src={OutschoolIcon} alt='Outschool logo' />
          </div>
          <div className='flex-auto'>
            <span className='block text-4xl font-semibold'>{t('components.outschoolCard.outschool')}</span>
            <div className='block my-[0.125rem] space-x-[0.125rem] text-honey'>
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
            </div>
            <span className='block text-xl font-semibold'>{t('components.outschoolCard.price')}</span>
          </div>
        </div>
        <div className='my-3'>
          <div className='text-center inline-block'>
            <img src={TopicEnglish} className='mx-3 lg-bs:mx-1.5 xl-bs:mx-3' alt='' />
            <span className='text-2xs uppercase'>{t('components.outschoolCard.class1')}</span>
          </div>
          <div className='text-center inline-block'>
            <img src={TopicMath} className='mx-3 lg-bs:mx-1.5 xl-bs:mx-3' alt='' />
            <span className='text-2xs uppercase'>{t('components.outschoolCard.class2')}</span>
          </div>
          <div className='text-center inline-block'>
            <img src={TopicScience} className='mx-3 lg-bs:mx-1.5 xl-bs:mx-3' alt='' />
            <span className='text-2xs uppercase'>{t('components.outschoolCard.class3')}</span>
          </div>
          <div className='text-center inline-block'>
            <img src={TopicMusic} className='mx-3 lg-bs:mx-1.5 xl-bs:mx-3' alt='' />
            <span className='text-2xs uppercase'>{t('components.outschoolCard.class4')}</span>
          </div>
          <div className='text-center inline-block'>
            <img src={TopicPreK} className='mx-3 lg-bs:mx-1.5 xl-bs:mx-3' alt='' />
            <span className='text-2xs uppercase'>{t('components.outschoolCard.class5')}</span>
          </div>
          <div className='text-center inline-block'>
            <img src={TopicLifeSkills} className='mx-3 lg-bs:mx-1.5 xl-bs:mx-3' alt='' />
            <span className='text-2xs uppercase'>{t('components.outschoolCard.class6')}</span>
          </div>
        </div>
        <span className='block font-semibold text-sm mb-1'>{t('components.outschoolCard.subtitle')}</span>
        <p className='font-light text-sm mb-3'>{t('components.outschoolCard.details')}</p>
        <button type='button' className='inline-block bg-sapphire text-white rounded-full py-1.5 px-4 hover:no-underline hover:text-white hover:opacity-70'>
          {t('components.outschoolCard.button')}
        </button>
      </div>
    </a>
  );
};
